import { Directive, HostListener, HostBinding, OnInit } from '@angular/core';
import { LeafletDirective } from 'src/app/directives/leaflet/core/leaflet.directive';
import { LeafletDirectiveWrapper } from 'src/app/directives/leaflet/core/leaflet.directive.wrapper';
import { UserService } from '../../services/user.service';

@Directive({
  selector: '[leafletCtrlToZoom]',
  standalone: false,
})
export class LeafletCtrlToZoomDirective implements OnInit {
  @HostBinding('class') scrollClass = '';

  leafletDirective: LeafletDirectiveWrapper;

  debounceTimerHideScrollMessage: ReturnType<typeof setTimeout> = null;
  debounceTimerShowScrollMessage: ReturnType<typeof setTimeout> = null;
  debounceTimerDisableZoom: ReturnType<typeof setTimeout> = null;
  debounceTimerEnableZoom: ReturnType<typeof setTimeout> = null;

  hideScrollMessageTimeout: number = 3000;
  showScrollMessageTimeout: number = 3000;
  disableZoomTimeout: number = 3000;
  enableZoomTimeout: number = 1000;

  @HostListener('mousewheel', ['$event']) onMouseWheelChrome(event: any) {
    this.mouseWheelFunc(event);
  }

  @HostListener('DOMMouseScroll', ['$event']) onMouseWheelFirefox(event: any) {
    this.mouseWheelFunc(event);
  }

  @HostListener('onmousewheel', ['$event']) onMouseWheelIE(event: any) {
    this.mouseWheelFunc(event);
  }

  constructor(
    leafletDirective: LeafletDirective,
    public userSettings: UserService
  ) {
    this.leafletDirective = new LeafletDirectiveWrapper(leafletDirective);
  }

  ngOnInit() {
    this.leafletDirective.getMap().scrollWheelZoom.disable();
  }

  mouseWheelFunc(event: any) {
    if (this.leafletDirective.getMap()) {
      event.stopPropagation();
      if (event.ctrlKey === true) {
        event.preventDefault();
        this.enableZoom();
        this.hideScrollMessage(false);
        this.disableZoom(true);
      } else {
        this.disableZoom(false);
        this.showScrollMessage();
        this.hideScrollMessage(true);
      }
    }
  }

  hideScrollMessage(timeout: boolean = false) {
    if (timeout) {
      if (this.debounceTimerHideScrollMessage) {
        clearTimeout(this.debounceTimerHideScrollMessage);
      }
      this.debounceTimerHideScrollMessage = setTimeout(() => {
        this.hideScrollMessage();
      }, this.hideScrollMessageTimeout);
    } else {
      this.debounceTimerHideScrollMessage = null;
      this.scrollClass = '';
    }
  }

  showScrollMessage(timeout: boolean = false) {
    if (timeout) {
      if (this.debounceTimerShowScrollMessage) {
        clearTimeout(this.debounceTimerShowScrollMessage);
      }
      this.debounceTimerShowScrollMessage = setTimeout(() => {
        this.showScrollMessage();
      }, this.showScrollMessageTimeout);
    } else {
      this.debounceTimerShowScrollMessage = null;
      this.scrollClass = this.userSettings.selectedLanguage() === 'de' ? ' scrollmessageDE' : ' scrollmessage';
    }
  }

  disableZoom(timeout: boolean = false) {
    if (timeout) {
      if (this.debounceTimerDisableZoom) {
        clearTimeout(this.debounceTimerDisableZoom);
      }
      this.debounceTimerDisableZoom = setTimeout(() => {
        this.disableZoom();
      }, this.disableZoomTimeout);
    } else {
      this.debounceTimerDisableZoom = null;
      this.leafletDirective.getMap().scrollWheelZoom.disable();
    }
  }

  enableZoom(timeout: boolean = false) {
    if (timeout) {
      if (this.debounceTimerEnableZoom) {
        clearTimeout(this.debounceTimerEnableZoom);
      }
      this.debounceTimerEnableZoom = setTimeout(() => {
        this.enableZoom();
      }, this.enableZoomTimeout);
    } else {
      this.debounceTimerEnableZoom = null;
      this.leafletDirective.getMap().scrollWheelZoom.enable();
    }
  }
}
